import Countdown from "react-countdown";
import './CountdownTimer.css';



const CountdownTimer = ({ targetDate }) => {
  return (
    <Countdown
      date={targetDate} // Target date for countdown
      renderer={({ days, hours, minutes, seconds }) => (

        <div className="counter">

          {/* Days section */}
          <div className="counter-item">
            <h3 id="day">{String(days).padStart(2, "0")}</h3>
            <span>日</span>
          </div>

          {/* Hours section */}
          <div className="counter-item">
            <h3 id="hour">{String(hours).padStart(2, "0")}</h3>
            <span>小時</span>
          </div>

          {/* Minutes section */}
          <div className="counter-item">
            <h3 id="minute">{String(minutes).padStart(2, "0")}</h3>
            <span>分鐘</span>
          </div>

          {/* Seconds section */}
          <div className="counter-item">
            <h3 id="second">{String(seconds).padStart(2, "0")}</h3>
            <span>秒</span>
          </div>

        </div>
      )}
    />
  );
};

export default CountdownTimer;